import React from "react";
import { getCreditsByPeriodicidadAsync } from "../../../api/Dashboard";
import DonaPorGrupo from "./DonaPorGrupo";

const CreditsByPeriodicidad = () => (
  <DonaPorGrupo
    titulo="Créditos por periodicidad"
    obtener={getCreditsByPeriodicidadAsync}
    nombre={(item) => item.periocidad}
    columna="Periodicidad"
    unidad={["crédito", "créditos"]}
    descripcionVacio="Aquí se muestran los créditos por periodicidad."
  />
);

export default CreditsByPeriodicidad;
